import { cn } from '@utils/helpers';
import type { ILoadingPagePerformanceChartProps } from './types';

export const LoadingPagePerformanceChart: React.FC<ILoadingPagePerformanceChartProps> = (props) => (
  <div className="relative z-2000 h-[370px] w-full">
    <div
      className={cn(
        'absolute left-1/2 top-1/2 h-[100px] w-[100px] -translate-x-1/2 -translate-y-1/2 rounded-md',
        props.fakeExtension ? 'bg-none' : 'bg-white bg-[url(/static/front/assets/fading-line-loader.gif)] bg-center bg-no-repeat',
      )}
    />
  </div>
);
